import { Reducer } from 'redux';
import _ from 'lodash';
import { IReduxAction } from 'app/types/actions';
import { ConnectActionTypes as types, IConnectState } from './types';

const initialState: IConnectState = {
};

const reducer: Reducer<IConnectState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.UPDATE_CONNECT_TEAM: {
      return _.merge({}, state.connect, action.payload);
    }
    default:
      return state;
  }
};

export default reducer;
